// extracted by mini-css-extract-plugin
export default {"mobFix":"Footer_mobFix__Ny9Jj","footer":"Footer_footer__V8Lu+"};